import styled from "styled-components/macro";


export const SettingsDeviceModeBg = styled.div`
background: var(--clr-settingsbg);
width: 100%;
height: 88%;
`;


export const SettingsDeviceModeBtnContainer = styled.div`
margin-top: 1.5em;
text-align: center;
border-top-right-radius: 100%;
`;

export const SettingsDeviceModeTelBtn = styled.button`
  padding: 1em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  background: ${({ active }) => (active ? "#1f729f" : "gray")};

  /* &:focus {
    background-color: #1f729f;
  } */
`;


export const SettingsDeviceModeMonBtn = styled.button`
  padding: 1em 1.5em;
  border: #414340;
  background: gray;
  color: #edebeb;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  background: ${({ active }) => (!active ? "#1f729f" : "gray")};
 
`;